module.exports = __webpack_public_path__ + "img/first_it.c6be05d3.jpg";